/*
 * @Descripttion:
 * @version:
 * @Author: 廖图图
 * @Date: 2021-11-16 09:18:11
 * @LastEditors: 廖图图
 * @LastEditTime: 2022-03-28 14:09:09
 */
import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 公司默认自定义页面数据
 */
const companyFrontEndPageDefaultParam = {
  /**
   * 获取公司默认自定义页面数据
   */
  getCompanyFrontEndPageDefaultParam(
    companyId,
    pagePath,
    param,
    pageInstanceName = ""
  ) {
    return axios.post(
      base.companyFrontEndPageDefaultParam.getCompanyFrontEndPageDefaultParam,
      utils.postParamsArrayToJsonString({
        companyId,
        pagePath,
        param,
        pageInstanceName,
      })
    );
  },
  /**
   * 获取公司默认自定义页面数据
   */
  getCompanyFrontEndPageDefaultParam2(companyId, pagesPath) {
    if (pagesPath instanceof Array) {
      pagesPath = JSON.stringify(pagesPath);
    }
    return axios.post(
      base.companyFrontEndPageDefaultParam.getCompanyFrontEndPageDefaultParam2,
      utils.postParamsArrayToJsonString({ companyId, pagePath })
    );
  },
  /**
   * 设置公司默认自定义页面数据
   */
  setCompanyFrontEndPageDefaultParam(companyId, pagePath, param, value) {
    let pageInstanceName = "";
    return axios.post(
      base.companyFrontEndPageDefaultParam.setCompanyFrontEndPageDefaultParam,
      utils.postParamsArrayToJsonString({
        companyId,
        pagePath,
        param,
        value,
        pageInstanceName,
      })
    );
  },
  /**
   * 删除公司默认自定义页面数据
   */
  deleteCompanyFrontEndPageDefaultParam(
    companyId,
    pagePath,
    param,
    pageInstanceName
  ) {
    return axios.post(
      base.companyFrontEndPageDefaultParam
        .deleteCompanyFrontEndPageDefaultParam,
      utils.postParamsArrayToJsonString({
        companyId,
        pagePath,
        param,
        pageInstanceName,
      })
    );
  },
};

export default companyFrontEndPageDefaultParam;
